module.exports = __webpack_public_path__ + "img/ios.6ddc990d.png";